import React, { useState, useEffect } from 'react'
import { Table, DataTable, Pagination, LoadingFull } from '@arnsbogroup/react-voicearchive'
import { useHistory } from 'react-router-dom'
import { FormattedDate, FormattedTime } from 'react-intl'
import useCurrentUser from 'hooks/useCurrentUser'

const Span = ({ children }) => <span>{ children }</span>

const CreateDate = ({ children }) => <span>
  <FormattedDate value={new Date(children * 1000)} /> <FormattedTime value={new Date(children * 1000)} />
</span>

const Medias = ({ medias }) => {
  const list = (medias) ? medias.map((media) => media.name).join(', ') : [];
  return <span>{list}</span>
}

const Suppliers = ({ suppliers }) => {
  const list = (suppliers) ? suppliers.map((supplier) => supplier.userid).join(', ') : [];
  return <span>{list}</span>
}

const ClosedOrders = ( {customer, onChange} ) => {
  if (!customer) {
    return null
  }

  const history = useHistory();
  const { features = [] } = useCurrentUser()

  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    pages: 0,
    total: 0
  });

  useEffect(() => {
    fetchClosedOrders();
  }, [customer]);

  const fetchClosedOrders = (page = 1) => {
    setLoading(true)
    const params = new URLSearchParams({
      stage: 'CLOSED',
      'customerId[]': customer.uid,
      page: Math.max(page - 1, 0), // The API is zero indexed, the Pagination component is not
      pageSize: 20,
      orderBy: 'uid',
      orderDirection: 'DESC',
      includeRelations: 1
    });

    fetch(`/rest/v2/order?${params}`)
      .then((response) => response.json())
      .then((data) => {
        setOrders(data.data);
        setPagination(data.meta);
        setLoading(false)
      });
  };

  const onClick = (orderId) => {
    history.push(`/orders/${orderId}/overview`)
  }

  function onPaginationChangeHandler(page) {
    fetchClosedOrders(page);
  }
  
  return (
    <div>
      { loading ? (
        <LoadingFull />
      ) : (
        <div className='p-4'>
          <DataTable
            className="w-full"
            components={{
            Tr: ({ childProps = {}, ...innerProps }) => {
                return (
                <Table.Tr className="cursor-pointer" onClick={childProps.uid ? () => onClick(childProps.uid) : undefined}
                    {...innerProps }
                />
                )
            },
            Td: Table.Td
            }}
            head={{
              name: { label: 'Name' },
              crdate: { label: 'Created' },
              total: { label: 'Total Price (€)' },
              totalCost: { label: 'Total Cost (€)' },
              contact_name: { label: 'Contact' },
              coordinator_name: { label: 'Coordinator' },
              medias: { label: 'Medias' },
              suppliers: { label: 'Suppliers' },
            }}
            body={{
              name: Span,
              crdate: CreateDate,
              total: Span,
              totalCost: Span,
              contact_name: Span,
              coordinator_name: Span,
              medias: Medias,
              suppliers: Suppliers,
            }}
            entries={orders}
          />
          <Pagination
            onChange={onPaginationChangeHandler}
            pageSize={pagination.pageSize}
            page={pagination.currentPage}
            totalItems={pagination.total}
          ></Pagination>
        </div>
      )}
    </div>
  )
}

export default ClosedOrders
